<template>
    <div class="main">
        <c-panel title="CATÁLOGO DO CONSÓRCIO" titleIcon="fas fa-notebook-2">
            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Consórcio" class="u-mb-0">
                            <el-select v-model="consorcioId" filterable style="width: 100%;" @change="mudouConsorcio">
                                <el-option v-for="c in consorcios" :key="c.id" :value="c.id"
                                    :label="c.nome + (c.municipio_gestor ? ' (gestor)' : ' (associado)')"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Entidade" class="u-mb-0">
                            <el-select v-model="entidade" style="width: 100%;" @change="carregar">
                                <el-option v-for="e in entidades" :key="e.valor" :value="e.valor" :label="e.rotulo"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" class="u-text-right u-mt-25">
                        <el-button size="small" icon="el-icon-refresh" @click="carregar">ATUALIZAR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-alert v-if="ehGestor" type="success" :closable="false" class="u-mb-15"
                title="Esta instalação é a GESTORA deste consórcio."
                description="Aqui você publica os itens padronizados. Os municípios associados os consomem pelo catálogo central."></el-alert>
            <el-alert v-else-if="consorcioId" type="info" :closable="false" class="u-mb-15"
                title="Esta instalação é ASSOCIADA."
                description="Os itens vêm do catálogo central e ficam somente leitura. Use a prévia antes de sincronizar."></el-alert>

            <el-row class="u-mb-15">
                <el-col :span="24" class="u-text-right">
                    <el-button v-if="podeEscrever && ehGestor" type="primary" size="small" icon="el-icon-plus"
                        @click="abrirPublicar()">PUBLICAR ITEM</el-button>
                    <el-button class="u-ml-10" v-if="podeEscrever" size="small" icon="el-icon-view"
                        :disabled="!consorcioId" @click="verPrevia">PRÉVIA</el-button>
                    <el-button class="u-ml-10" v-if="podeEscrever" size="small" type="warning" icon="el-icon-refresh-right"
                        :disabled="!consorcioId" @click="sincronizar">SINCRONIZAR</el-button>
                    <el-button class="u-ml-10" size="small" icon="el-icon-time" :disabled="!consorcioId" @click="verHistorico">HISTÓRICO</el-button>
                </el-col>
            </el-row>

            <div v-if="dados" class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 120px;">Código</th>
                            <th>Item</th>
                            <th style="width: 90px;" class="u-text-center">Versão</th>
                            <th style="width: 120px;" class="u-text-center">Obrigatório</th>
                            <th style="width: 100px;" class="u-text-center">Situação</th>
                            <th style="width: 160px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="i in dados.itens" :key="i.id">
                            <td>{{ i.codigo }}</td>
                            <td>{{ i.nome }}</td>
                            <td class="u-text-center">v{{ i.versao }}</td>
                            <td class="u-text-center">
                                <el-tag v-if="i.obrigatorio" size="mini" type="warning">sim</el-tag>
                                <span v-else>—</span>
                            </td>
                            <td class="u-text-center">
                                <el-tag size="mini" :type="i.situacao ? 'success' : 'info'">{{ i.situacao ? 'Ativo' : 'Inativo' }}</el-tag>
                            </td>
                            <td class="u-text-center acao">
                                <el-button v-if="podeEscrever && ehGestor" size="mini" plain @click="abrirPublicar(i)">EDITAR</el-button>
                                <el-button class="u-ml-10" v-if="podeEscrever && ehGestor && i.situacao" size="mini" type="danger" plain
                                    @click="remover(i)">DESATIVAR</el-button>
                                <span v-if="!ehGestor">somente leitura</span>
                            </td>
                        </tr>
                        <tr v-if="dados.itens.length === 0"><td colspan="6" class="u-text-center">Nenhum item nesta entidade.</td></tr>
                    </tbody>
                </table>
            </div>

            <!-- ==================== PUBLICAR ==================== -->
            <el-dialog :title="form.id ? 'Editar item do catálogo' : 'Publicar item no catálogo'" :visible.sync="dialogo" width="640px">
                <el-alert type="info" :closable="false" class="u-mb-15"
                    title="Alterar um item já publicado incrementa a versão."
                    description="É a versão que faz os municípios associados perceberem a mudança na próxima sincronização."></el-alert>

                <el-form label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8">
                            <el-form-item label="Código">
                                <el-input v-model="form.codigo" :disabled="!!form.id" placeholder="PROF"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="16">
                            <el-form-item label="Nome">
                                <el-input v-model="form.nome" placeholder="Professor"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Tipo de cargo (item 123) -->
                    <el-form-item v-if="entidade === 'tipo_cargo'" label="Descrição">
                        <el-input v-model="form.dados.descricao" type="textarea" :rows="2"></el-input>
                    </el-form-item>

                    <!-- Tipo de avaliação (item 124) -->
                    <div v-else>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="8">
                                <el-form-item label="Natureza">
                                    <el-select v-model="form.dados.natureza" style="width: 100%;">
                                        <el-option value="numerica" label="Numérica"></el-option>
                                        <el-option value="conceitual" label="Conceitual"></el-option>
                                        <el-option value="descritiva" label="Descritiva"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="4">
                                <el-form-item label="Nota mínima">
                                    <el-input-number v-model="form.dados.nota_minima" :min="0" :precision="2" controls-position="right" style="width: 100%;"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="4">
                                <el-form-item label="Nota máxima">
                                    <el-input-number v-model="form.dados.nota_maxima" :min="0" :precision="2" controls-position="right" style="width: 100%;"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="4">
                                <el-form-item label="Média de aprovação">
                                    <el-input-number v-model="form.dados.media_aprovacao" :min="0" :precision="2" controls-position="right" style="width: 100%;"></el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="4">
                                <el-form-item label="Casas decimais">
                                    <el-input-number v-model="form.dados.casas_decimais" :min="0" :max="3" controls-position="right" style="width: 100%;"></el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <el-checkbox v-model="form.obrigatorio">
                        Obrigatório — o município associado não pode desativar este item
                    </el-checkbox>
                </el-form>

                <span slot="footer">
                    <el-button @click="dialogo = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" :disabled="!form.codigo || !form.nome" @click="publicar">PUBLICAR</el-button>
                </span>
            </el-dialog>

            <!-- ==================== PRÉVIA ==================== -->
            <el-dialog title="Prévia da sincronização" :visible.sync="dialogoPrevia" width="700px">
                <div v-if="previa">
                    <el-alert type="info" :closable="false" class="u-mb-15"
                        :title="'Origem: ' + previa.origem"
                        :description="previa.aviso"></el-alert>

                    <el-row :gutter="10" class="u-mb-15">
                        <el-col :xs="12" :sm="6"><div class="kpi"><span class="n">{{ previa.novos.length }}</span><span class="r">Novos</span></div></el-col>
                        <el-col :xs="12" :sm="6"><div class="kpi"><span class="n">{{ previa.atualizados.length }}</span><span class="r">A atualizar</span></div></el-col>
                        <el-col :xs="12" :sm="6"><div class="kpi"><span class="n">{{ previa.sem_mudanca }}</span><span class="r">Sem mudança</span></div></el-col>
                        <el-col :xs="12" :sm="6"><div class="kpi kpi-alerta"><span class="n">{{ previa.a_desativar.length }}</span><span class="r">A desativar</span></div></el-col>
                    </el-row>

                    <div v-if="previa.novos.length">
                        <h4 class="u-mb-5">Serão criados</h4>
                        <p><el-tag v-for="n in previa.novos" :key="n.codigo" size="mini" class="u-mr-5">{{ n.codigo }} — {{ n.nome }}</el-tag></p>
                    </div>
                    <div v-if="previa.atualizados.length">
                        <h4 class="u-mb-5">Serão atualizados</h4>
                        <p>
                            <el-tag v-for="u in previa.atualizados" :key="u.codigo" size="mini" type="warning" class="u-mr-5">
                                {{ u.codigo }} (v{{ u.versao_local }} → v{{ u.versao_remota }})
                            </el-tag>
                        </p>
                    </div>
                    <div v-if="previa.a_desativar.length">
                        <h4 class="u-mb-5">Serão desativados</h4>
                        <p><el-tag v-for="d in previa.a_desativar" :key="d.codigo" size="mini" type="danger" class="u-mr-5">{{ d.codigo }}</el-tag></p>
                    </div>

                    <small class="u-text-muted">
                        {{ previa.itens_locais_proprios }} item(ns) criados pelo próprio município
                        permanecem intactos e editáveis.
                    </small>
                </div>
                <span slot="footer">
                    <el-button @click="dialogoPrevia = false">FECHAR</el-button>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" @click="sincronizarDaPrevia">SINCRONIZAR AGORA</el-button>
                </span>
            </el-dialog>

            <!-- ==================== HISTÓRICO ==================== -->
            <el-dialog title="Histórico de sincronizações" :visible.sync="dialogoHist" width="800px">
                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 150px;">Data/hora</th>
                                <th style="width: 130px;">Entidade</th>
                                <th style="width: 110px;">Direção</th>
                                <th style="width: 220px;" class="u-text-center">Resultado</th>
                                <th style="width: 110px;" class="u-text-center">Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="h in historico" :key="h.id">
                                <td>{{ dataHora(h.executado_em) }}</td>
                                <td>{{ h.entidade }}</td>
                                <td>{{ h.direcao }}</td>
                                <td class="u-text-center">
                                    <span v-if="h.situacao === 'concluida'">
                                        {{ h.qtd_criados }} criado(s) · {{ h.qtd_atualizados }} atualizado(s) · {{ h.qtd_ignorados }} ignorado(s)
                                    </span>
                                    <small v-else class="u-text-muted">{{ h.retorno }}</small>
                                </td>
                                <td class="u-text-center">
                                    <el-tag size="mini" :type="h.situacao === 'concluida' ? 'success' : 'danger'">{{ h.situacao }}</el-tag>
                                </td>
                            </tr>
                            <tr v-if="historico.length === 0"><td colspan="5" class="u-text-center">Nenhuma sincronização registrada.</td></tr>
                        </tbody>
                    </table>
                </div>
                <span slot="footer"><el-button @click="dialogoHist = false">FECHAR</el-button></span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO M — itens 123 e 124: publicação e sincronização do catálogo. */
export default {
    data: () => ({
        consorcioId: null, entidade: 'tipo_cargo', consorcios: [], entidades: [],
        dados: null, previa: null, historico: [],
        dialogo: false, dialogoPrevia: false, dialogoHist: false,
        form: { id: null, codigo: '', nome: '', obrigatorio: false, dados: {} }
    }),
    computed: {
        podeEscrever () { return [4, 5].includes(parseInt(this.$store.state.user.tipo)) },
        ehGestor () {
            const c = this.consorcios.find(x => x.id === this.consorcioId)
            return !!(c && c.municipio_gestor)
        }
    },
    mounted () {
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/consorcio/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.entidades = (r.data && r.data.entidades) ? r.data.entidades : [] })
         .catch(e => this.$store.commit('throwException', e))

        this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/consorcio/getAllPaginate?page=1`,
            {}, this.$store.getters.getHeaderAuth
        ).then(r => {
            this.consorcios = r.data.data || []
            if (this.$route.query.consorcio) this.consorcioId = parseInt(this.$route.query.consorcio)
            else if (this.consorcios.length) this.consorcioId = this.consorcios[0].id
            if (this.consorcioId) this.carregar()
        }).catch(e => this.$store.commit('throwException', e))
    },
    methods: {
        mudouConsorcio () { this.dados = null; this.carregar() },
        carregar () {
            this.dados = null
            if (!this.consorcioId) return

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/consorcio/itens/${this.consorcioId}`,
                { entidade: this.entidade }, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.dados = r.data
            }).catch(e => this.$store.commit('throwException', e))
        },
        abrirPublicar (item) {
            if (item) {
                this.form = {
                    id: item.id, codigo: item.codigo, nome: item.nome,
                    obrigatorio: !!item.obrigatorio,
                    dados: JSON.parse(JSON.stringify(item.dados || {}))
                }
            } else {
                this.form = { id: null, codigo: '', nome: '', obrigatorio: false,
                              dados: this.entidade === 'tipo_avaliacao'
                                ? { natureza: 'numerica', nota_minima: 0, nota_maxima: 10,
                                    media_aprovacao: 6, casas_decimais: 1, arredondamento: 'normal',
                                    qtd_exames_finais: 0, permite_recuperacao_periodo: false, situacao: true }
                                : { descricao: '', situacao: true } }
            }
            this.dialogo = true
        },
        publicar () {
            const dados = Object.assign({}, this.form.dados, { nome: this.form.nome })

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/consorcio/publicarItem`,
                { consorcio_id: this.consorcioId, entidade: this.entidade, codigo: this.form.codigo,
                  nome: this.form.nome, dados: dados, obrigatorio: this.form.obrigatorio },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                this.dialogo = false
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        remover (item) {
            this.$confirm(`Desativar "${item.nome}" no catálogo? Os municípios associados o receberão como inativo — o item local não é apagado.`,
                'Confirmação', { confirmButtonText: 'Desativar', cancelButtonText: 'Cancelar', type: 'warning' }
            ).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/consorcio/removerItem/${item.id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        verPrevia () {
            this.previa = null
            this.dialogoPrevia = true

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/consorcio/previa/${this.consorcioId}/${this.entidade}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    this.dialogoPrevia = false; return
                }
                this.previa = r.data
            }).catch(e => this.$store.commit('throwException', e))
        },
        sincronizarDaPrevia () { this.dialogoPrevia = false; this.sincronizar() },
        sincronizar () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/consorcio/sincronizar/${this.consorcioId}/${this.entidade}`,
                {}, this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', {
                    msg: `${r.data.criados} criado(s), ${r.data.atualizados} atualizado(s), ${r.data.desativados} desativado(s).`,
                    type: 'success'
                })
                this.carregar()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        verHistorico () {
            this.historico = []
            this.dialogoHist = true

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/consorcio/sincronizacoes/${this.consorcioId}`,
                {}, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) return
                this.historico = r.data.data || []
            }).catch(e => this.$store.commit('throwException', e))
        },
        dataHora (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]} ${d.substring(11, 16)}`
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.kpi { border: 1px solid #dcdfe6; border-radius: 4px; padding: 10px; text-align: center; margin-bottom: 8px; }
.kpi .n { display: block; font-size: 20px; font-weight: bold; }
.kpi .r { display: block; font-size: 11px; color: #606266; }
.kpi-alerta { border-left: 4px solid #e6a23c; }
</style>
